export const recentDealData = [
    {
        deal_name: "Web developement deal with alex",
        deal_price: "450",
        dealr_name: "Alexandra Della",
        dealr_img: "/images/avatar/1.png",
        clossing_date: "22 March, 2023"
    },
    {
        deal_name: "Web developement deal with alex",
        deal_price: "550",
        dealr_name: "Green Cute",
        dealr_img: "/images/avatar/2.png",
        clossing_date: "22 March, 2023"
    },
    {
        deal_name: "Web developement deal with alex",
        deal_price: "850",
        dealr_name: "Holmes Cherryman",
        dealr_img: "/images/avatar/3.png",
        clossing_date: "22 March, 2023"
    },
    {
        deal_name: "Web developement deal with alex",
        deal_price: "900",
        dealr_name: "Malanie Hanvey",
        dealr_img: "/images/avatar/4.png",
        clossing_date: "22 March, 2023"
    },

]